import { Elm } from "../../assets/elm/AdvancedCookiesMessage"

document.addEventListener("DOMContentLoaded", () => {
  Elm.AdvancedCookiesMessage.init({
    node: document.getElementById("advancedCookiePreferencesMessage"),
    flags: gon.accept_cookies_message
  })
})



// WEBPACK FOOTER //
// ./app/frontend/packs/advanced_cookies_message.js